import { colors } from '../../colors'

interface PageContainerProps {
  children: React.ReactNode
  maxWidth?: string
  backgroundColor?: string
  className?: string
  style?: React.CSSProperties
}

const styles: Record<string, React.CSSProperties> = {
  wrapper: {
    backgroundColor: colors['background-light'],
    minHeight: '100vh',
    width: '100%',
  },
  container: {
    maxWidth: '800px',
    margin: '0 auto',
    backgroundColor: colors.white,
    minHeight: '100vh',
  },
}

const PageContainer: React.FC<PageContainerProps> = ({
  children,
  maxWidth = '800px',
  backgroundColor = colors.white,
  className,
  style,
}) => {
  return (
    <div style={styles.wrapper}>
      <div
        className={className}
        style={{
          ...styles.container,
          maxWidth,
          backgroundColor,
          ...style,
        }}
      >
        {children}
      </div>
    </div>
  )
}

export default PageContainer
